export const telegramNickname = 'ibragimov16';

export const telegramLink = `https://t.me/${telegramNickname}`;
